<template>
  <v-container fluid>
    <v-card :class="{ 'form-disabled': isFormDisabled }">
      <v-row class="mx-6">
        <v-col v-for="(services, category) in servicesGrouped" :key="category" cols="12">
          <h3>{{ category }}</h3>
          <v-row class="ml-3">
            <v-col v-for="service in services" :key="service.id" cols="12" class="p-5">
              <v-checkbox
                v-model="selectedServices"
                :value="service.id"
                :label="service.name"
                hide-details
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pb-0">
          <v-btn style="background-color: #273978; color: white;" class="float-right" outlined :disabled="loading" :loading="loading"
            @click="saveDetails">
            {{ isFormDisabled ? 'Next' : 'Save' }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import rules from '../../../utilities/validator';
import _ from 'lodash';
import {
  agencyFeesAmountForJobScope,
  fetchSinodaAgencyFeesCardId,
} from '../../../utilities/agencyFeesByJobScope';

export default {
  name: 's-services-opted',
  props: {
    operation: {
      type: Object,
      default: () => ({}),
    },
    isDraft: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      rules,
      services: [],
      servicesGrouped: {},
      catalog_id: [],
      selectedServices: [],
      select: [],
      selectAll: false,
      loading: false,
    };
  },
  computed: {
    isFormDisabled() {
      return ['Billing', 'Completed', 'Cancelled'].includes(this.operation.status) && !['admin'].includes(this.$store.state.auth.profile.role);
    }
  },
  methods: {
    handleOperationInit() {
      // Load catalog first so `services` / `catalog_id` exist before merging Agency Fees into selection.
      this.fetchServiceCatalog().then(() => this.populateServices());
    },
    populateServices() {
      return this.$api.operation_billed_items.get_services_list(this.operation.id)
        .then((response) => {
          this.selectedServices = [...(response.service_catalogs || [])];
          this.ensureAgencyFeesSelected();
        }).catch((err) => {
          this.$store.dispatch('setAlert', {
            status: 'error',
            show: true,
            message: err.message,
          });
        });
    },
    /** Always include Agency Fees catalog id in `selectedServices` once catalog is loaded. */
    ensureAgencyFeesSelected() {
      const idx = this.services.findIndex((name) => name === 'Agency Fees');
      if (idx === -1) return;
      const id = this.catalog_id[idx];
      if (id != null && !this.selectedServices.includes(id)) {
        this.selectedServices.push(id);
      }
    },
    fetchServiceCatalog() {
      return this.$api.service_catalogs.getServiceCatalogName()
        .then((response) => {
          // Create an array of objects containing both service names and catalog IDs
          const servicesWithIds = response.service_catalog_names.map((name, index) => ({
            name,
            id: response.service_catalog_ids[index],
            category: response.categories[index],
          }));

          // Sort the categories alphabetically
          const sortedCategories = _.sortBy(_.uniq(servicesWithIds.map(service => service.category)));

          // Initialize an empty object to hold grouped services
          const groupedServices = {};

          // Group services by category
          sortedCategories.forEach(category => {
            const servicesInCategory = servicesWithIds.filter(service => service.category === category);
            groupedServices[category] = _.sortBy(servicesInCategory, 'name');
          });

          this.servicesGrouped = groupedServices;

          this.services = servicesWithIds.map(service => service.name);
          this.catalog_id = servicesWithIds.map(service => service.id);

          this.ensureAgencyFeesSelected();
        }).catch((err) => {
          this.$store.dispatch('setAlert', {
            status: 'error',
            show: true,
            message: err.message,
          });
        });
    },

    saveDetails() {
      this.loading = true;
      fetchSinodaAgencyFeesCardId(this.$api)
        .then((sinodaCardId) => {
          const selectedIndex = [];

          this.services.forEach((service, index) => {
            const serviceId = this.catalog_id[index];
            if (this.selectedServices.includes(serviceId)) {
              const serviceDetails = {
                id: serviceId,
                name: service,
                card_id: null,
                amount: null
              };

              if (service === 'Agency Fees') {
                serviceDetails.card_id = sinodaCardId;
                const amt = agencyFeesAmountForJobScope(this.operation.job_scope);
                if (amt != null) {
                  serviceDetails.amount = amt;
                }
              }
              selectedIndex.push(serviceDetails);
            }
          });
          const requestData = {
            operationId: this.operation.id,
            selectedIndex
          };
          return this.$api.operation_billed_items.createService(requestData);
        })
        .then((response) => {
          this.selectedServices = response.selectedServices;
          this.loading = false;
          this.$emit('nextStep', 3);
        })
        .catch((err) => {
          this.$store.dispatch('setAlert', {
            status: 'error',
            show: true,
            message: err.message,
          });
          this.loading = false;
        });
    },
  },
  watch: {
    operation(value) {
      this.handleOperationInit();
    }
  },
  created() {
    this.handleOperationInit();
  }
};
</script>

<style scoped>
  .p-5 {
    padding: 5px;
  }

  .form-disabled .v-checkbox {
    pointer-events: none;
    opacity: 0.8;
  }

  .form-disabled .v-input {
    pointer-events: none;
    opacity: 0.8;
  }

  .form-disabled .v-input__control {
    pointer-events: none;
    opacity: 0.8;
  }

  .form-disabled .v-input__control .v-input__slot {
    pointer-events: none;
    opacity: 0.8;
  }

  .form-disabled .v-input__control .v-input__slot .v-input--selection-controls__input {
    pointer-events: none;
    opacity: 0.8;
  }

  .form-disabled h3 {
    opacity: 0.8;
  }
</style>